import auth from './auth';
import vca from './vca';
import forms from './forms';
import misc from './misc';

export default {
  auth,
  vca,
  forms,
  misc,
};
